import React from 'react'
import styled from 'styled-components'
import { Regular, Medium, MqTablet, MqDesktop } from 'streamr-ui/css/consts'
import { PrimaryButton, ButtonSize } from 'streamr-ui'
import node from './assets/node.png'
import node2x from './assets/node@2x.png'
import sponsor from './assets/sponsor.png'
import sponsor2x from './assets/sponsor@2x.png'
import delegator from './assets/delegator.png'
import delegator2x from './assets/delegator@2x.png'
import bounty from './assets/bounty.png'
import bounty2x from './assets/bounty@2x.png'
import publisherApp from './assets/publisher_app.png'
import publisherApp2x from './assets/publisher_app@2x.png'
import stakePool from './assets/stake_pool.png'
import stakePool2x from './assets/stake_pool@2x.png'
import Topic from '~shared/Topic'
import Container from '~shared/Container'
import Spacer from '~shared/Spacer'
import ButtonWrapper from '~shared/ButtonWrapper'
import Br from '~shared/Br'
import urls from '~utils/urls'

const Icon = styled.div`
    width: 45px;
    height: 45px;

    img {
        max-width: 60px;
        max-height: 60px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    @media ${MqTablet} {
        width: 50px;
        height: 50px;
    }

    @media ${MqDesktop} {
        width: 80px;
        height: 80px;

        img {
            max-width: 100px;
            max-height: 100px;
        }
    }
`

const Title = styled.h3`
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: ${Medium};
    margin: 0;

    @media ${MqDesktop} {
        font-size: 1.25rem;
        line-height: 1.875rem;
    }
`

const Description = styled.p`
    font-size: 0.75rem;
    line-height: 1.25rem;
    margin: 0;
    width: 90%;

    @media ${MqTablet} {
        min-height: 3.75rem;
    }

    @media ${MqDesktop} {
        font-size: 1.125rem;
        line-height: 1.875rem;
        min-height: 5.625rem;
    }
`

const Card = styled.div`
    background-color: #fafafa;
    border-radius: 4px;
    min-height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 16px 0 128px;
    position: relative;

    ${Icon} {
        position: absolute;
        left: 40px;
        top: 50%;
        transform: translateY(-50%);
    }

    @media ${MqTablet} {
        min-height: 144px;
        padding: 0 16px 0 120px;
    }

    @media ${MqDesktop} {
        min-height: 240px;
        padding: 0 48px 0 232px;

        ${Icon} {
            left: 80px;
        }
    }
`

const Column = styled.div`
    ${Card} + ${Card} {
        margin-top: 1rem;
    }

    @media ${MqTablet} {
        ${Card} + ${Card} {
            margin-top: 2rem;
        }
    }
`

const Columns = styled.div`
    ${Column} {
        flex: 1;
    }

    ${Column} + ${Column} {
        margin-top: 1rem;
    }

    @media ${MqTablet} {
        display: flex;
        flex-direction: row;

        ${Column} + ${Column} {
            margin-left: 2rem;
            margin-top: 0;
        }
    }
`

const DocsLink = styled.div`
    text-align: center;

    h3 {
        font-size: 1.25rem;
        font-weight: ${Regular};
        line-height: 2rem;
        margin: 0;
        margin-bottom: 2.5rem;
    }

    @media ${MqTablet} {
        h3 {
            font-size: 1.5rem;
        }
    }

    @media ${MqDesktop} {
        h3 {
            font-size: 1.625rem;
        }
    }
`

const UnstyledRolesAndEntities = (props) => (
    <Topic {...props}>
        <Container>
            <Columns>
                <Column>
                    <Card $appear>
                        <Icon>
                            <img src={node} srcSet={`${node2x} 2x`} alt="Operator" />
                        </Icon>
                        <Title>Operator</Title>
                        <Description>
                            Operates Streamr nodes and stakes on Sponsorships via their
                            Operator&nbsp;contract
                        </Description>
                    </Card>
                    <Card $appear>
                        <Icon>
                            <img src={sponsor} srcSet={`${sponsor2x} 2x`} alt="Sponsor" />
                        </Icon>
                        <Title>Sponsor</Title>
                        <Description>
                            Funds Sponsorships to incentivise Operators to secure and
                            relay&nbsp;streams
                        </Description>
                    </Card>
                    <Card $appear>
                        <Icon>
                            <img src={delegator} srcSet={`${delegator2x} 2x`} alt="Delegator" />
                        </Icon>
                        <Title>Delegator</Title>
                        <Description>
                            Delegates $DATA to Operators and earns a revenue share of the
                            Operator&apos;s work in&nbsp;return
                        </Description>
                    </Card>
                </Column>
                <Column>
                    <Card $appear>
                        <Icon>
                            <img src={bounty} srcSet={`${bounty2x} 2x`} alt="Sponsorship" />
                        </Icon>
                        <Title>Sponsorship</Title>
                        <Description>
                            Sponsorships pay out $DATA tokens over time to staked
                            Operator&nbsp;contracts
                        </Description>
                    </Card>
                    <Card $appear>
                        <Icon>
                            <img
                                src={publisherApp}
                                srcSet={`${publisherApp2x} 2x`}
                                alt="Publisher App"
                            />
                        </Icon>
                        <Title>Publisher App</Title>
                        <Description>
                            Publishes streams to the Network to be relayed by Streamr&nbsp;nodes
                        </Description>
                    </Card>
                    <Card $appear>
                        <Icon>
                            <img
                                src={stakePool}
                                srcSet={`${stakePool2x} 2x`}
                                alt="Operator contract"
                            />
                        </Icon>
                        <Title>Operator contract</Title>
                        <Description>
                            Allows Delegators to delegate on Operators and share&nbsp;revenue
                        </Description>
                    </Card>
                </Column>
            </Columns>
            <Spacer as={DocsLink} head="3.75rem,7.5rem,9rem">
                <h3 $appear>
                    Dive into the Tokenomics
                    <Br mobile />
                    docs to learn more
                </h3>
                <ButtonWrapper>
                    <PrimaryButton tag="a" size={ButtonSize.Moose} href={urls.docs.dataToken}>
                        Tokenomics docs
                    </PrimaryButton>
                </ButtonWrapper>
            </Spacer>
        </Container>
    </Topic>
)

const RolesAndEntities = styled(UnstyledRolesAndEntities)`
    padding-top: 6.5rem;
    padding-bottom: 5.875rem;
    background-color: white;

    ${Container} {
        padding: 0 1rem;
    }

    ${ButtonWrapper} {
        margin-top: 25px;
    }

    @media ${MqTablet} {
        padding-top: 9rem;

        ${Container} {
            max-width: 44rem;
            padding: 0;
        }

        ${ButtonWrapper} {
            margin-top: 50px;
        }
    }

    @media ${MqDesktop} {
        padding-top: 10.5rem;
        padding-bottom: 13.125rem;

        ${Container} {
            max-width: 72.5rem;
        }
    }
`

export default RolesAndEntities
